export class Note {
  constructor(){}

  id: string;
  application_id: string;
  note: string;
  user_id: string;
  user_name: string;
  organization_name: string;
  createdate: string;
  adminnote: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/note.ts